import theme from 'common/lib/theme/staticTheme';

// If window width is less than this, then sidebar is collapsed by default.
export const SIDEBAR_BREAKPOINT_PX = theme.breakPoints.md;
